import { Grid } from '@cmg/design-system';
import type { FC, PropsWithChildren } from 'react';

export const FormLayout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Grid container px={1}>
      {children}
    </Grid>
  );
};
